<section class="contact-list">
  <header class="title">Contactos</header>

  @for (contact of contacts(); track contact.id) {
    <div
      class="contact-preview"
      [class.is-disabled]="disabled()"
      (click)="onSelect(contact.id)"
      role="button"
      [attr.tabindex]="disabled() ? -1 : 0"
      (keydown.enter)="onSelect(contact.id)"
      (keydown.space)="onSelect(contact.id)"
      [attr.aria-disabled]="disabled()"
      [attr.aria-label]="'Contact ' + contact.fullName"
    >
      <div class="avatar-container">
        <img
          src="assets/images/irec_agente.jpg"
          class="img"
          [alt]="contact.fullName + ' profile picture'"
          loading="lazy"
        />
        <div class="online-indicator"></div>
      </div>
      <div class="contact-details">
        <div class="contact-info">
          <h3 class="fullname">{{ contact.fullName }}</h3>
          <p class="about">{{ contact.phoneNumber }}</p>
        </div>
      </div>
    </div>
  }

  @if (!contacts().length) {
    <div class="empty-state">
      <div class="empty-icon">📱</div>
      <h3>Sin contactos</h3>
      <p>Agrega contactos para empezar a chatear</p>
    </div>
  }
</section>
